// extracted by mini-css-extract-plugin
module.exports = {"disabled":"SimpleDMSWidget_disabled__UIj_b"};